import React from 'react'
import {findDOMNode} from "react-dom"

import Popover from '../../../core/gd-components/gd-popover/popover-v2'
import PopoverPosition from '../../../core/gd-components/gd-popover/popover-position'
import {PopoverAttachmentType} from '../../../core/gd-components/gd-popover/@const'
import PopoverMenu from "../../../core/gd-components/popover-menu/popover-menu/popover-menu"
import UI5ControlButton from "../../app-controls/buttons/button/button";

type State = {
    showPopover : boolean,
    reRender?   : boolean
}

type Props = {
    className?      : string

    menuOptions     : Option[]

    iconClass?      : string        // if set will use class instead of default

    onTogglePopover?: {(showPopover:boolean):void}
}

export default class MainMenu_MoreButton extends React.Component<Props,State> {

    constructor(props:any) {
        super(props)

        this.state = {
            showPopover: false
        }
    }

    reRender = () => {
        this.setState({reRender: true})
    }

    showPopover = (e:React.SyntheticEvent) => {
        e.stopPropagation();
        if (!this.state.showPopover) {
            this.setState({
                showPopover: true
            }, ()=>{if (this.props.onTogglePopover) this.props.onTogglePopover(true)})
        }
    };

    hidePopover = () => {
        if (this.state.showPopover) {
            this.setState({
                showPopover: false
            }, ()=>{if (this.props.onTogglePopover) this.props.onTogglePopover(false)})
        }
    };

    renderPopover() {
        return (
            <Popover popoverClass       = "ui-menu-more-popover w-220"
                     constraints        = {[{
                         to: 'window',
                         attachment: 'together',
                         // to: 'scrollParent',
                         pin: true
                     }]}
                     position           = {new PopoverPosition({
                         attachment      : "top left",
                         targetAttachment: "top right",
                         attachmentType  : PopoverAttachmentType.VERTICAL,
                         offset          : "0 0",
                     })}
                     getTargetFunc      = {()=>findDOMNode(this)}
                     onClickOutside     = {()=>{this.hidePopover()}}>

                    <PopoverMenu options        = {this.props.menuOptions}
                                 hidePopover    = {this.hidePopover} />
            </Popover>
        )
    }

    render() {

        const iconClass : string = _.get(this.props,'iconClass','i5-more fs-20')

        const classes = Classes("ui5-control-button s-24 more", iconClass, this.props.className, {
            'popover-shown': this.state.showPopover
        })

        return (
            <div className={classes} onClick={this.showPopover}>
                {this.state.showPopover &&
                    this.renderPopover()
                }
            </div>
        )

    }
}
